import { useState } from 'react';
import { ReloadOutlined } from '@ant-design/icons';

const ChartCard = ({ title, chartRef, onReset, legendItems = [], staticLegend = false, children }) => {
  const [hiddenSets, setHiddenSets] = useState({});

  const handleLegendClick = (item, i) => {
    const chart = chartRef?.current;
    if (!chart) return;
    const indices = item.datasetIndices ?? [i];
    const isVisible = chart.isDatasetVisible(indices[0]);
    indices.forEach(idx => chart.setDatasetVisibility(idx, !isVisible));
    chart.update();
    setHiddenSets(prev => {
      const next = { ...prev };
      indices.forEach(idx => { next[idx] = isVisible; });
      return next;
    });
  };

  const handleReset = () => {
    onReset();
    setHiddenSets({});
  };

  return (
    <div className="chart-card">
      <div className="chart-title-row">
        <div className="chart-title">{title}</div>
      </div>
      {children}
      <div className="chart-legend-row">
        <div className="chart-legend-items">
          {legendItems.map((item, i) => (
            <span
              key={i}
              className={`chart-legend-item${!staticLegend && (item.datasetIndices ?? [i]).some(idx => hiddenSets[idx]) ? ' chart-legend-item--hidden' : ''}`}
              onClick={staticLegend ? undefined : () => handleLegendClick(item, i)}
            >
              <span className="chart-legend-box" style={{ backgroundColor: item.color }} />
              {item.label}
            </span>
          ))}
        </div>
        {!staticLegend && (
          <button className="chart-reset-btn" onClick={handleReset}>
            <ReloadOutlined style={{ fontSize: 16, color: 'rgba(0,0,0,0.88)' }} />
            선택 초기화
          </button>
        )}
      </div>
    </div>
  );
};

export default ChartCard;
